import React, { useEffect, useState, useRef, memo } from 'react';
import { Space, Table, Tag, Card, Select, Flex, Modal, Alert } from 'antd';

import { Button, Checkbox, Form, Input, Divider } from 'antd';
import ImagePicker from "components/pickers/image/MultiImagePicker"
import ProductService from 'services/product';
import { useParams, useNavigate } from "react-router"
import { useForm, useWatch } from "antd/es/form/Form";
import ProductOptionService from 'services/product_option'
import ProductVariantService from 'services/product_variant'
import { useApp } from 'contexts/app';
import InputNumber from "components/input-number"
import { PlusOutlined } from '@ant-design/icons';
import ProductOptionPicker from "components/pickers/product-option"
import _ from "lodash"
const service = new ProductService();
const productOptionService = new ProductOptionService();
const productVariantService = new ProductVariantService();

const AtrributePicker = ({ onChange, value, onOptionAdded }) => {
  const { prompt } = useApp();
  const [from] = useForm();
  useEffect(() => {

    var lst = [];

    if (_.isArray(value)) {
      lst = value;
    } else {

    }
    lst = lst.filter(x => x != "default")
    from.setFieldsValue({ options: lst })


  }, [value])


  const [selected, setSelected] = useState([]);
  useEffect(() => {
    loadProductOptions();
  }, [])
  const [productOptions, setProductOptions] = useState([]);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    //  setIsModalOpen(false);
    from.submit();
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const loadProductOptions = async () => {
    var lst = await productOptionService.list();
    lst = lst.filter(x => x.id != "default");
    setProductOptions(lst);
  }

  const handleChange = (v) => {
    setSelected(v);
  }
  const onFinish = (values) => {

    setIsModalOpen(false)
    var options = value;
    // if (options.length == 0) {
    //   options = ['default'];
    // }
    var { add_option } = values;
    if (options.includes(add_option)) {
      return;
    }
    options.push(add_option)
    onChange([...options])
  }


  const addNewProductOption = () => {

    prompt({
      title: "Thêm mới thuộc tính", label: "Nhập Tên",
      onOk: async (text) => {
        const service = new ProductOptionService();
        var p = await service.create({ title: text });
        await loadProductOptions();
        // var data = from.getFieldsValue();
        // data.options.push(p.id);
        // from.setFieldsValue(data);
        if (onOptionAdded) {
          onOptionAdded(p)
        }

       
        var data = { add_option: p.id }
        from.setFieldsValue(data);
      //  from.submit();


      }
    });
  }


  return (
    <>
      <Button type="link" onClick={showModal}>
        <PlusOutlined></PlusOutlined> Thuộc tính (size, màu ...)
      </Button>
      <Modal
        title="Thuộc tính sản phẩm"
        closable={{ 'aria-label': 'Custom Close Button' }}
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <Form form={from} onFinish={onFinish}>
          {/* <Form.Item name="options" >
            <Select
              mode="multiple"
              allowClear
              style={{ width: '100%' }}
              placeholder="Thuộc tính sản phẩm"
              options={productOptions.map(x => ({ value: x.id, label: x.title }))}
            />
          </Form.Item> */}
          <Form.Item name="add_option" >
            <Select

              allowClear
              style={{ width: '100%' }}
              placeholder="Thuộc tính sản phẩm"
              options={productOptions.map(x => ({ value: x.id, label: x.title }))}

              dropdownRender={menu => (
                <>
                  {menu}
                  <Divider style={{ margin: '8px 0' }} />
                  <Space style={{ padding: '0 8px 4px' }}>

                    <Space direction='vertical'>
                      <Alert closable message="Bạn có thể thêm mới các thuộc tính như 'Màu sắc', 'Size', 'Trọng lượng', 'Kích thước' ...vv cho sản phẩm" type="info"
                        description={<Button onClick={addNewProductOption}><PlusOutlined></PlusOutlined> Tạo thuộc tính </Button>}
                      >
                      </Alert>
                    </Space>
                  </Space>
                </>
              )}

            />
          </Form.Item>
        </Form>



      </Modal>
    </>
  );
};
export default memo(AtrributePicker);